import { logoutAfterSessionExpiry } from './sessionExpiredLogout';

let isRedirectingToLogin = false;
const configuredClients = new WeakSet();

const hasUnauthorizedStatus = (responseOrError) => {
    const status = responseOrError?.response?.status
        ?? responseOrError?.response?.data?.status
        ?? responseOrError?.status
        ?? responseOrError?.data?.status;

    return status === 401;
};

const logoutForUnauthorizedResponse = () => {
    if (isRedirectingToLogin) {
        return;
    }

    isRedirectingToLogin = true;
    logoutAfterSessionExpiry();
};

// Registers the handler only once for each Axios client.
export const configureUnauthorizedHandler = (axiosClient) => {
    if (configuredClients.has(axiosClient)) {
        return;
    }

    configuredClients.add(axiosClient);

    axiosClient.interceptors.response.use(
        (response) => {
            if (hasUnauthorizedStatus(response)) {
                logoutForUnauthorizedResponse();
            }

            return response;
        },
        (error) => {
            if (hasUnauthorizedStatus(error)) {
                logoutForUnauthorizedResponse();
            }

            return Promise.reject(error);
        }
    );
};
